module.exports = __webpack_public_path__ + "img/4.04.8e3aad60.jpg";